import { TableHead, TableRow, TableCell } from '@mui/material'
import { useTranslation } from 'react-i18next'

const columnNames = [
  'id',
  'projectNumber',
  'researchAreaNumber',
  'roundId',
  'round',
  'isExtraRound',
  'researcher',
  'roundDate',
  'created',
  'status',
]

export const HoursReportingTableHead = (): JSX.Element => {
  const { t } = useTranslation('hoursReporting')

  return (
    <TableHead sx={{ borderRadius: 8 }}>
      <TableRow>
        {columnNames.map((columnName) => (
          <TableCell key={columnName}>
            {t(`columnNames.${columnName}`)}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
